import { render, staticRenderFns } from "./PriceDay.vue?vue&type=template&id=1feaa4b3&scoped=true"
import script from "./PriceDay.vue?vue&type=script&lang=js"
export * from "./PriceDay.vue?vue&type=script&lang=js"
import style0 from "./PriceDay.vue?vue&type=style&index=0&id=1feaa4b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feaa4b3",
  null
  
)

export default component.exports